import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import LoginPage from './pages/LoginPage';
import SetupPage from './pages/SetupPage';
import DashboardPage from './pages/DashboardPage';
import VertraegePage from './pages/VertraegePage';
import VertragDetailPage from './pages/VertragDetailPage';
import VertragFormPage from './pages/VertragFormPage';
import VertragScanPage from './pages/VertragScanPage';
import AuswertungenPage from './pages/AuswertungenPage';
import AusgabenPage from './pages/AusgabenPage';
import AusgabeFormPage from './pages/AusgabeFormPage';
import AusgabenAuswertungPage from './pages/AusgabenAuswertungPage';
import KuendigungenPage from './pages/KuendigungenPage';
import DokumentePage from './pages/DokumentePage';
import DokumentDetailPage from './pages/DokumentDetailPage';
import SearchPage from './pages/SearchPage';
import AssistantPage from './pages/AssistantPage';
import ZahlungenPage from './pages/ZahlungenPage';
import ZahlungFormPage from './pages/ZahlungFormPage';
import ZahlungenAuswertungPage from './pages/ZahlungenAuswertungPage';
import KontoauszugPage from './pages/KontoauszugPage';
import BudgetPage from './pages/BudgetPage';
import FinanzberichtPage from './pages/FinanzberichtPage';
import HaushaltPage from './pages/HaushaltPage';
import AusgabenplanerPage from './pages/AusgabenplanerPage';
import Layout from './components/Layout';
import KalenderPage from './pages/KalenderPage';
import KuendigungsDetailPage from './pages/KuendigungsDetailPage';
import KuendigungsAssistentPage from './pages/KuendigungsAssistentPage';
import KuendigungsVorlagenPage from './pages/KuendigungsVorlagenPage';
import AufgabenPage from './pages/AufgabenPage';
import AutomatisierungenPage from './pages/AutomatisierungenPage';
import VertragsGesundheitPage from './pages/VertragsGesundheitPage';
import WissensbasisPage from './pages/WissensbasisPage';
import PruefCenterPage from './pages/PruefCenterPage';
import AnbieterPage from './pages/AnbieterPage';
import AnbieterDetailPage from './pages/AnbieterDetailPage';
import KontaktePage from './pages/KontaktePage';
import KontaktDetailPage from './pages/KontaktDetailPage';
import KommunikationPage from './pages/KommunikationPage';
import KommunikationDetailPage from './pages/KommunikationDetailPage';
import KostenPage from './pages/KostenPage';
import ImportPage from './pages/ImportPage';
import ExportPage from './pages/ExportPage';
import EinstellungenPage from './pages/EinstellungenPage';
import ProfilPage from './pages/ProfilPage';
import ReportsPage from './pages/ReportsPage';
import OptimierungPage from './pages/OptimierungPage';
import RadarPage from './pages/RadarPage';
import VergleichPage from './pages/VergleichPage';
import PosteingangPage from './pages/PosteingangPage';
import ActionsPage from './pages/ActionsPage';
import SimulationPage from './pages/SimulationPage';
import BenachrichtigungenPage from './pages/BenachrichtigungenPage';
import BankStatementPage from './pages/BankStatementPage';
import PaperlessScanPage from './pages/PaperlessScanPage';
import CrossSourcePage from './pages/CrossSourcePage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0f172a' }}>
      <div style={{ color: '#6366f1', fontSize: 24 }}>⏳ Laden...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/setup" element={<SetupPage />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="vertraege" element={<VertraegePage />} />
            <Route path="vertraege/neu" element={<VertragFormPage />} />
            <Route path="vertraege/scan" element={<VertragScanPage />} />
            <Route path="vertraege/:id" element={<VertragDetailPage />} />
            <Route path="vertraege/:id/bearbeiten" element={<VertragFormPage />} />
            <Route path="auswertungen" element={<AuswertungenPage />} />
            <Route path="kuendigungen" element={<KuendigungenPage />} />
            <Route path="kuendigungen/vorgaenge/:id" element={<KuendigungsDetailPage />} />
            <Route path="kuendigungen/vorlagen" element={<KuendigungsVorlagenPage />} />
            <Route path="ki/vertrag/:id" element={<KuendigungsAssistentPage />} />
            <Route path="dokumente" element={<DokumentePage />} />
            <Route path="dokumente/:id" element={<DokumentDetailPage />} />
            <Route path="suche" element={<SearchPage />} />
            <Route path="assistant" element={<AssistantPage />} />
            <Route path="ausgaben" element={<AusgabenPage />} />
            <Route path="ausgaben/neu" element={<AusgabeFormPage />} />
            <Route path="ausgaben/auswertung" element={<AusgabenAuswertungPage />} />
            <Route path="ausgaben/:id/bearbeiten" element={<AusgabeFormPage />} />
            <Route path="zahlungen" element={<ZahlungenPage />} />
            <Route path="zahlungen/neu" element={<ZahlungFormPage />} />
            <Route path="zahlungen/auswertung" element={<ZahlungenAuswertungPage />} />
            <Route path="zahlungen/:id/bearbeiten" element={<ZahlungFormPage />} />
            <Route path="kontoauszug" element={<KontoauszugPage />} />
            <Route path="budget" element={<BudgetPage />} />
            <Route path="finanzbericht" element={<FinanzberichtPage />} />
            <Route path="haushalt" element={<HaushaltPage />} />
            <Route path="ausgabenplaner" element={<AusgabenplanerPage />} />
            <Route path="kalender" element={<KalenderPage />} />
            <Route path="aufgaben" element={<AufgabenPage />} />
            <Route path="automatisierungen" element={<AutomatisierungenPage />} />
            <Route path="gesundheit" element={<VertragsGesundheitPage />} />
            <Route path="wissensbasis" element={<WissensbasisPage />} />
            <Route path="pruef-center" element={<PruefCenterPage />} />
            <Route path="anbieter" element={<AnbieterPage />} />
            <Route path="anbieter/:id" element={<AnbieterDetailPage />} />
            <Route path="anbieter/:id/bearbeiten" element={<AnbieterDetailPage editMode />} />
            <Route path="kontakte" element={<KontaktePage />} />
            <Route path="kontakte/:id" element={<KontaktDetailPage />} />
            <Route path="kommunikation" element={<KommunikationPage />} />
            <Route path="kommunikation/:id" element={<KommunikationDetailPage />} />
            <Route path="kosten" element={<KostenPage />} />
            <Route path="import" element={<ImportPage />} />
            <Route path="export" element={<ExportPage />} />
            <Route path="einstellungen" element={<EinstellungenPage />} />
            <Route path="profil" element={<ProfilPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="optimierung" element={<OptimierungPage />} />
            <Route path="radar" element={<RadarPage />} />
            <Route path="vergleich" element={<VergleichPage />} />
            <Route path="posteingang" element={<PosteingangPage />} />
            <Route path="paperless" element={<PaperlessScanPage />} />
            <Route path="actions" element={<ActionsPage />} />
            <Route path="simulation" element={<SimulationPage />} />
            <Route path="benachrichtigungen" element={<BenachrichtigungenPage />} />
            <Route path="kontoauszuege" element={<BankStatementPage />} />
            <Route path="entdeckung" element={<CrossSourcePage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
